/**
 * Hand history helpers shared by legacy Table tabs and casino overlays.
 */

export function getLosingKnockedHands(h, allSeats) {
  if (h.losingKnockedHands && h.losingKnockedHands.length) {
    return h.losingKnockedHands;
  }
  const winners = Array.isArray(h.winnerIdx)
    ? h.winnerIdx
    : h.winnerIdx != null
      ? [h.winnerIdx]
      : [];
  return (h.knocked || [])
    .filter((idx) => !winners.includes(idx))
    .map((idx) => ({
      playerIdx: idx,
      playerName: allSeats[idx]?.name || 'Unknown',
      hand: null,
      handType: null,
    }));
}
